import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ListQiwaContract_OPS from "./ListQiwaContract";
import {
  getQiwaContractData,
  getQiwaContractRenewData,
} from "../../../../../../store/Api";
import nodeinstance from "../../../../../../nodeInstance";

export default function QiwaContractTab_OPS(props) {
  const Client = useSelector((state) => state.qiwaDataRenew);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  const updateData = () => {
    // dispatch(getQiwaContractRenewData(token));
    getData();
  };

  const [data, setData] = useState();

  const getData = async () => {
    try {
      const response = await nodeinstance.get(
        `/qiwaContract/getData/${"ops"}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      console.log("error to be seen in console", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div className={`p-2  sm:p-5 `}>
        <ListQiwaContract_OPS
          list={data}
          loading={loading}
          titles={[
            "S.NO.",
            "EMPLOYEE ID",
            "EMPLOYEE Name",
            "RELIGION",
            "NATIONALITY",
            "CURRENT SPONSOR",
            "CLIENT",
            "UPLOAD INSTANCE",
            "STATUS",
            "ACTION",
          ]}
          token={token}
          updateData={updateData}
        />
      </div>
    </>
  );
}
